import React, {createContext, useContext, useEffect, useRef, useState} from "react";
import {MainContextProvider} from "./MainContext";
import {NotificationType} from "../helpers/types";
import {useDispatch, useSelector, useStore} from "react-redux";
import {pushNotification} from "../redux/slices/notificationsSlice";
import {pushToBottomMessages, setTabNotifications} from "../redux/slices/ChatSlice";
import {RootState} from "../redux/store";

interface SocketContextProps {}

export const SocketContext = createContext<SocketContextProps | undefined>(undefined);

export const WebSocketProvider: React.FC = ({ children,  }) => {
    const store = useStore()
    const selectedChatId = useSelector((state: RootState) => state.chat.selectedChatId);
    const dispatch = useDispatch();
    const { userData, centrifuge, setModalType, setModalData } = useContext(MainContextProvider)
    const socketRef = useRef<WebSocket | null>(null);

    const connectSocket = () => {
        if (socketRef.current) return

        socketRef.current = centrifuge.subscribe(`user#${userData?.user_id}`, function(ctx: any) {
            const currentId = store.getState().chat.selectedChatId
            const chats = store.getState().chat.chats
            const tabNotifications = store.getState().chat.tabNotifications
            console.log('ctx', ctx)

            if (ctx?.data?.["request-type"] === "notifications" && ctx.data.notification) {
                dispatch(pushNotification(ctx.data.notification))

                if (ctx.data.notification.type === 'SYSTEM') {
                    setModalType('server_reload')
                    setModalData({ hideClose: true })
                }
            }

            if (ctx?.data?.["request-type"] === "chat" && ctx.data.comments) {
                if ((String(currentId) !== String(ctx.data.comments.chat_id)) && (chats.find((el: { id: string }) => (String(el.id) === String(ctx.data.comments.chat_id))))) {

                    const newTabNotifications = tabNotifications.map((el: any) => {
                        if (String(el.id) === String(ctx.data.comments.chat_id)) {
                            return {
                                ...el,
                                new_comments_count: String(+el.new_comments_count + 1)
                            }
                        }
                        return el
                    })
                    dispatch(setTabNotifications(newTabNotifications))
                }
            }

            if (ctx?.data?.["request-type"] === "chat" && ctx.data.comments) {
                if (String(currentId) !== String(ctx.data.comments.chat_id)) return
                store.dispatch(pushToBottomMessages([ctx.data.comments]))
            }
        });
    }

    useEffect(() => {
        if (userData && centrifuge) connectSocket()
    }, [centrifuge, userData])

    return (
        <SocketContext.Provider value={{
            socketRef
        }}>
            {children}
        </SocketContext.Provider>
    );
}